import {
  __esm,
  __spreadValues
} from "./chunk-ZU6LNBSF.mjs";

// src/icons/CopyFilled.tsx
import React from "react";
var SvgCopyFilled, CopyFilled_default;
var init_CopyFilled = __esm({
  "src/icons/CopyFilled.tsx"() {
    SvgCopyFilled = (props) => /* @__PURE__ */ React.createElement(
      "svg",
      __spreadValues({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24"
      }, props),
      /* @__PURE__ */ React.createElement(
        "path",
        {
          fill: "currentColor",
          d: "M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
        }
      )
    );
    CopyFilled_default = SvgCopyFilled;
  }
});

export {
  CopyFilled_default,
  init_CopyFilled
};
